define('lib/validator/ValidatorIsEqual',['require','lib/validator/ValidatorAbstract'],function (require) {

    var ValidatorAbstract = require('lib/validator/ValidatorAbstract');

    return ValidatorAbstract.extend({

        _value: null,
        _error: null,

        initialize: function () {
            ValidatorAbstract.prototype.initialize.apply(this, arguments);
            
            this._value = this.getOption('value');
            this._error = this.getOption('error');
        },

        /**
         * Validates value
         *
         * @param mixed value
         */
        validate: function (value) {
            var vValue = this._value;
            if(typeof this._value === 'function') {
                vValue = this._value();
            }
            if (value !== vValue) {
                this.addError(this._error);
            }
        }

    });

});
